import React from 'react';

function SvgEchIconPlay(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      {...props}
    >
      <defs>
        <linearGradient
          id="a54e9a5b-b46a-456f-bb61-a80cad1f50cf"
          x1={16.67}
          y1={6.01}
          x2={5.23}
          y2={-15.86}
          gradientTransform="matrix(1, 0, 0, -1, 0, 6)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#faa829" />
          <stop offset={1} stopColor="#ff3f00" />
        </linearGradient>
      </defs>
      <path
        d="M6.5,3.87,18.7,12,6.5,20.13Z"
        fill="none"
        strokeWidth={2}
        stroke="url(#a54e9a5b-b46a-456f-bb61-a80cad1f50cf)"
      />
    </svg>
  );
}
export default SvgEchIconPlay;
